import axios from "axios";


// Handles FormData for file upload, returns {success, error}
export async function sendSollicitatieMail(mail) {
    const url = process.env.REACT_APP_API_BASE_URL + "/mails/sollicitatie";
    try {
      await axios.post(url, mail, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return { success: true };
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        return { success: false, error: e.response.data.error };
      }
      return { success: false, error: 'Er is een fout opgetreden. Probeer het later opnieuw.' };
    }
}


// Handles JSON, returns {success, error}
export async function sendContactMail(mail) {
  const url = process.env.REACT_APP_API_BASE_URL + `/mails/contact`;
  try {
    await axios.post(url, { mail });
    return { success: true };
  } catch (e) {
    if (e.response && e.response.data && e.response.data.error) {
      return { success: false, error: e.response.data.error };
    }
    return { success: false, error: 'Er is een fout opgetreden. Probeer het later opnieuw.' };
  }
}

const exportedFunctions = {
    sendSollicitatieMail,
    sendContactMail,
  };

export default exportedFunctions;
